import { API_BASE_URL } from "../config/api";
import { resolveApiMessage } from "../utils/resolveApiMessage";

export async function fetchPurchaseOrders({ cnpjEmitente, cnpjRemetente, pedido, item }) {
  const url = new URL("/order/pi", API_BASE_URL);

  const response = await fetch(url.toString(), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ cnpjEmitente, cnpjRemetente, pedido, item }),
  });

  const text = await response.text();

  let data;
  try {
    data = JSON.parse(text);
  } catch {
    throw new Error("Não foi possível conectar ao servidor. Verifique se o backend está ativo.");
  }

  if (!response.ok || data.status === "nok") {
    if (data.errorType === "NO_RESULTS") {
      return [];
    }
    throw new Error(resolveApiMessage(data, "Erro ao buscar pedidos no SAP PI"));
  }

  return data.data.map((item, index) => ({
    id: `${item.pedido}-${item.item_pedido}-${index}`,
    poNumber: item.pedido,
    poItem: item.item_pedido,
    erpMaterial: item.cod_material,
    shortText: item.desc_material,
    qty: item.quantidade_po,
    uom: item.uom_po,
    iva: item.iva,
    ncm: item.ncm,
    deposito: item.deposito ?? '',
    adm_lote: item.adm_lote ?? '',
    lote: item.lote ?? '',
    unidades_validas: item.unidades_validas ?? [],
  }));
}
